// extracted by mini-css-extract-plugin
export default {"modalBody":"p6AGRsGpuWB6XdSeXDP7","avatar":"k7HdXwnUniJW0zcEZWxU","loader":"yFoniMQsjzNnfvI2s51v","table":"Pmy5tRfYU_wWkjINxO9Q","notFound":"ClBeDUDSTkuob2p5yNKW"};